import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const ResponseIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 14;
  const color = props.color || '#383838';
  return <Icon name={'response'} size={size} color={color} />;
};

export default React.memo(ResponseIcon);
